module.exports = __webpack_public_path__ + "img/016.11c34b59.jpg";